import React, { useEffect, useState } from "react";
import BuildingDreamsSections from "./Admissions/BuildingDreamsSections";
import ChooseUs from "./Admissions/ChooseUs";
import ThirdSection from "./Admissions/ThirdSection";
import DaySection from "./Admissions/DaySection";
import AdmissionGallery from "./Admissions/AdmissionGallery";
import Footer from "../components/Footer";
import TestimonialSlider from "./Admissions/TestimonialSlider";
import ContactUs from "./Admissions/ContactUs";
import { testimonialImages } from "../utils/constants";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import YoutubeModal from "./custom/YoutubeModal";
import HomeTestimonialSlider from "./HomePage/HomeTestimonialSlider";
import rightArrowImg from "../assets/rightarrow.png"
import leftArrowImg from "../assets/leftarrow.png"
import { Helmet } from "react-helmet";

const Admission = () => {
  const [youtubeModal, setYoutubeModal] = useState(false);
  const [youtubeUrl, setYoutubeUrl] = useState(null);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    centerMode: true,
    centerPadding: "0px",
    nextArrow: (
      <div>
        <img className="custom-arrow" src={rightArrowImg} alt="Next" />
      </div>
    ),
    prevArrow: (
      <div>
        <img className="custom-arrow" src={leftArrowImg} alt="Previous" />
      </div>
    ),
  };

  useEffect(() => {
    window.scrollTo(0, 20);
  }, []);

  return (
    <div>
      <Helmet>
        <title>Pre School Admission | Play School Admission | Nursery School Admission | Contact Us - Mother's Pride</title>
        <meta name="description" content="Mother's Pride, a best play school brand is open for admissions for the session 2025-26. Admissions Open | Kindergarten School" />
        <meta name="keywords" content="Pre School Admission, Play School Admission, Nursery School Admission" />
      </Helmet>
      <BuildingDreamsSections />
      <ChooseUs />
      <ThirdSection />
      <DaySection />
      <ContactUs />
      <HomeTestimonialSlider bgColor={"white"}/>
      <AdmissionGallery />
      <Footer marginX={"4%"} />
      {youtubeModal && (
        <YoutubeModal url={youtubeUrl} setOpenModal={setYoutubeModal} />
      )}
    </div>
  );
};

export default Admission;
